import {useStore} from '@/store/root-store';
import {LoadingOutlined} from '@ant-design/icons';
import {Spin} from 'antd';
import {observer} from 'mobx-react';
import {useState} from 'react';
import styled from 'styled-components';
import {Analytics} from './Analytics';
import {CompetingFocusTermsDrawer} from './SideDrawers/CompetingFocusTermsDrawer';
import {ContentIdeasDrawer} from './SideDrawers/ContentIdeasDrawer';
import {ContentResearchDrawer} from './SideDrawers/ContentResearchDrawer/ContentResearchDrawer';
import {KeywordsDrawer} from './SideDrawers/KeywordsDrawer';
import {Technicals} from './Technicals';
import {CompetitorsHeadingsDrawer} from './SideDrawers/CompetitorsHeadingsDrawer';

export const SidebarContent = observer(() => {
  const [showTechnicals, setShowTechincals] = useState(false);

  let htmlToDraft = null;
  if (typeof window === 'object') {
    htmlToDraft = require('html-to-draftjs').default;
  }

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  const antIconSecond = <LoadingOutlined style={{fontSize: 14, color: '#7f4ead', marginLeft: '12px', marginRight: '12px'}} spin />;

  // const currentView = showTechnicals ? <Technicals changeView={() => setShowTechincals(!showTechnicals)}/> : <Analytics changeView={() => setShowTechincals(!showTechnicals)}/>;
  const currentView = <>
    <TechnicalsContainer showTechnicals={showTechnicals}>
      <Technicals changeView={() => setShowTechincals(!showTechnicals)}/>
    </TechnicalsContainer>
    <ContentContainer showTechnicals={showTechnicals}>
      <Analytics changeView={() => setShowTechincals(!showTechnicals)}/>
    </ContentContainer>
  </>;

  return <Wrapper>
    <ContentIdeasDrawer />
    <CompetingFocusTermsDrawer />
    <CompetitorsHeadingsDrawer htmlToDraft={htmlToDraft}/>
    <ContentResearchDrawer />
    <KeywordsDrawer />
    <LoadingBannerContainer>
      {currentPage.isInitialPageLoad && <LongLoadingBanner>
        <Spin indicator={antIconSecond} />
        <span>{currentPage.isFetchingTargetKw ? 'Target keywords are being updated...' : 'Page data is being updated...'}</span>
      </LongLoadingBanner>}
    </LoadingBannerContainer>
    {currentView}
  </Wrapper>;
});

const Wrapper = styled.div`
  height: 100%;
  position: relative;
`;

const TechnicalsContainer = styled.div<{showTechnicals: boolean}>`
  position: absolute;  
  width: 100%;
  left: ${p => p.showTechnicals ? 0 : '400px'};

  @media only screen and (max-width: 1400px) {
    left: ${p => p.showTechnicals ? 0 : '350px !important'};
  }
  overflow-x: hidden;
  transition: all .3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 20px 20px;
`;

const ContentContainer = styled.div<{showTechnicals: boolean}>`
  position: absolute;
  width: 100%;
  left: ${p => !p.showTechnicals ? 0 : '-400px'};

  @media only screen and (max-width: 1400px) {
    left: ${p => !p.showTechnicals ? 0 : '-350px  !important'};
  }

  overflow-x: hidden;
  transition: all .3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 20px 20px;
`;

const LoadingBannerContainer = styled.div`
  background-color: transparent;
  height: 25px;
  width: 100%;
`;
const LongLoadingBanner = styled.div`
background: rgba(84, 41, 125, 0.5);
border-radius: 5px;
font-size: 12;
height: 25px;
padding-top: 2px;
width: 100%;
`;
